module.exports = __webpack_public_path__ + "static/img/network-2.691f18b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/register/network/network-2.png
// module id = soyV
// module chunks = 1